// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const List: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 39"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M49.9 3.6H13.1c-.6 0-1 .4-1 1v.8c0 .6.4 1 1 1h36.8c.6 0 1-.4 1-1v-.8c0-.6-.4-1-1-1zM8.4.6H1.6c-.6 0-1 .4-1 1v6.8c0 .6.4 1 1 1h6.8c.6 0 1-.4 1-1V1.6c0-.6-.4-1-1-1zm-5 6V3.4h3.2v3.2H3.4zm46.5 11.7H13.1c-.6 0-1 .4-1 1v.8c0 .6.4 1 1 1h36.8c.6 0 1-.4 1-1v-.8c0-.6-.4-1-1-1zm-41.5-3H1.6c-.6 0-1 .4-1 1v6.8c0 .6.4 1 1 1h6.8c.6 0 1-.4 1-1v-6.8c0-.6-.4-1-1-1zm-5 6v-3.2h3.2v3.2H3.4zm46.5 11.3H13.1c-.6 0-1 .4-1 1v.8c0 .6.4 1 1 1h36.8c.6 0 1-.4 1-1v-.8c0-.6-.4-1-1-1zm-41.5-3H1.6c-.6 0-1 .4-1 1v6.8c0 .6.4 1 1 1h6.8c.6 0 1-.4 1-1v-6.8c0-.6-.4-1-1-1zm-5 6v-3.2h3.2v3.2H3.4z"/></svg>;
};

export default React.memo(List);
